<template>
  <div>
    <HeroSection id="hero" />
    <ServicesSection id="services" />
    <BenefitsSection id="benefits" />
    <TestimonialsSection id="testimonials" />
    <ContactSection id="contact" />
  </div>
</template>

<script>
import HeroSection from '@/components/HeroSection.vue';
import ServicesSection from '@/components/ServicesSection.vue';
import BenefitsSection from '@/components/BenefitsSection.vue';
import TestimonialsSection from '@/components/TestimonialsSection.vue';
import ContactSection from '@/components/ContactSection.vue';

export default {
  name: 'HomeView',
  components: {
    HeroSection,
    ServicesSection,
    BenefitsSection,
    TestimonialsSection,
    ContactSection,
  },
};
</script>

<style scoped>
/* Estilos específicos para la página principal */
</style>